var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('LpButton',{staticClass:"u-w-full",attrs:{"icon":"&#xe5db;","ghost":"","target":"_blank","href":_vm.item.path}},[_vm._v("\n    "+_vm._s(_vm.item.name)+"\n")])
}
var staticRenderFns = []

export { render, staticRenderFns }